import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FiPlus, FiMinus } from "react-icons/fi";
import { useTranslation } from "react-i18next";

/**
 * Sıkça sorulan sorular — konu başlıklarına ayrılmış.
 * Cevaplar yalnızca sitede zaten yer alan bilgilere dayanır; koşula bağlı konularda (ödeme, asgari miktar)
 * somut vaat verilmez, teklifle birlikte bildirileceği söylenir.
 * Arama motorları için FAQPage yapılandırılmış verisi eklenir.
 */
const GRUPLAR = [
  { anahtar: "order", sorular: [["price", "/toptan-teklif"], ["howOrder", "/iletisim"], ["notInCatalog", "/iletisim"], ["productCatalogs", "/urunler"]] },
  { anahtar: "delivery", sorular: [["siteDelivery", "/toptan-teklif"], ["pickup", "/stores"]] },
  { anahtar: "wholesale", sorular: [["bulkSupply", "/toptan-teklif"], ["minQuantity", "/toptan-teklif"], ["cementForm", "/urunler/cimento"]] },
  { anahtar: "payment", sorular: [["paymentMethods", "/toptan-teklif"]] },
  {
    anahtar: "product",
    sorular: [["calculate", "/hesaplayicilar"], ["compare", "/urunler"], ["qualityStandards"], ["technicalSupport", "/iletisim"], ["training"]],
  },
];

const FAQSection = () => {
  const [acik, setAcik] = useState(null);
  const { t } = useTranslation();

  // Yapılandırılmış veri (FAQPage)
  useEffect(() => {
    const etiket = document.createElement("script");
    etiket.type = "application/ld+json";
    etiket.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: GRUPLAR.flatMap((g) =>
        g.sorular.map(([k]) => ({
          "@type": "Question",
          name: t(`faq.questions.${k}.question`),
          acceptedAnswer: { "@type": "Answer", text: t(`faq.questions.${k}.answer`) },
        }))
      ),
    });
    document.head.appendChild(etiket);
    return () => etiket.remove();
  }, [t]);

  return (
    <section className="section">
      <div className="mx-auto w-full max-w-3xl px-5 sm:px-6">
        <div className="page-head">
          <h1 className="page-title">{t("faq.title")}</h1>
          <p className="page-sub">{t("faq.subtitle")}</p>
        </div>

        {/* Konu kısayolları */}
        <nav className="mb-8 flex flex-wrap gap-2">
          {GRUPLAR.map((g) => (
            <a
              key={g.anahtar}
              href={`#sss-${g.anahtar}`}
              className="rounded-full border border-line px-3.5 py-1.5 text-[13px] text-body transition-colors hover:border-ink/30 hover:text-ink"
            >
              {t(`faq.groups.${g.anahtar}`)}
            </a>
          ))}
        </nav>

        <div className="space-y-10">
          {GRUPLAR.map((g) => (
            <div key={g.anahtar} id={`sss-${g.anahtar}`} className="scroll-mt-40">
              <h2 className="mb-2 text-[12px] font-semibold uppercase tracking-eyebrow text-muted">{t(`faq.groups.${g.anahtar}`)}</h2>
              <div className="divide-y divide-line border-y border-line">
                {g.sorular.map(([k, link]) => {
                  const id = `${g.anahtar}-${k}`;
                  const isOpen = acik === id;
                  return (
                    <div key={k}>
                      <button
                        onClick={() => setAcik(isOpen ? null : id)}
                        aria-expanded={isOpen}
                        className="flex w-full items-start justify-between gap-6 py-5 text-start"
                      >
                        <h3 className={`text-[15px] font-medium transition-colors duration-200 ${isOpen ? "text-ink" : "text-body"}`}>
                          {t(`faq.questions.${k}.question`)}
                        </h3>
                        <span className="mt-0.5 shrink-0 text-muted">{isOpen ? <FiMinus size={17} /> : <FiPlus size={17} />}</span>
                      </button>
                      <div className={`grid transition-all duration-300 ease-out ${isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"}`}>
                        <div className="overflow-hidden">
                          <p className="pe-10 text-[14px] leading-relaxed text-body">{t(`faq.questions.${k}.answer`)}</p>
                          {link && (
                            <Link to={link} className="link-arrow mb-6 mt-3 inline-flex text-[13px]">
                              {t(`faq.questions.${k}.link`, { defaultValue: t("faq.moreInfo") })}
                              <span aria-hidden="true" className="arrow-forward" />
                            </Link>
                          )}
                          {!link && <div className="pb-6" />}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 rounded-2xl bg-canvas p-6 text-center">
          <p className="text-[15px] text-body">{t("faq.contactPrompt")}</p>
          <Link to="/iletisim" className="btn-primary mt-4 inline-flex">
            {t("faq.contactButton")}
          </Link>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
